import React, { useState } from 'react'
import apiService from '../apiservice/apiService';

function Contact() {
    const [submitloader, setSubmitloader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [greenMessage, setGreenMessage] = useState('');
    const [formData, setFormData] = useState({
        full_name: '',
        work_email: '',
        phone_number: '',
        company_name: '',
        message: '',
      });

      const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        const optionalFields = ['company_name', 'phone_number']; // add your optional fields here

        // Check for empty fields except optional ones
        Object.keys(formData).forEach((key) => {
            if (!formData[key] && !optionalFields.includes(key)) {
                newErrors[key] = `${key.replace('_', ' ')} is required`;
            }
        });
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setGreenMessage('');
        if (!validateForm()) {
        setErrorMessage('Please fill the required fields before proceeding.');
        return;
        }

        setSubmitloader(true);

        try {
        const jsonParams = {
            full_name: formData.full_name,
            phone_number: formData.phone_number,
            work_email: formData.work_email,
            company_name: formData.company_name,
            message: formData.message,
        };

        // Convert object to query string
        const queryString = new URLSearchParams(jsonParams).toString();

        // Send GET request with query string
        const response = await apiService.post(`contact-us?${queryString}`);
        if (response && response.data && response.data.success === true) {
            setGreenMessage(response.data.message || "Details submitted successfully!");
            setErrorMessage('');
            setFormData({
                full_name: '',
                work_email: '',
                phone_number: '',
                company_name: '',
                message: '',
            });
        } else {
            setErrorMessage(response.data.message || "Failed. Please try again!");
        }
        } catch (error) {
        console.error("Submission error:", error);
        } finally {
        setSubmitloader(false);
        }
    };
  return (
    <div className="container-fluid aboutus_fullpage pt-5">
        <div className="row justify-content-center align-items-center">
            <div className="col-lg-10">
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-6 mb-4">
                        <div className="d-flex flex-column align-items-md-start align-items-center">
                            <h1 className="text-primary fw-bold">Get In <span className="text-black">Touch</span></h1>
                            <p>We always reply back within 24 hours</p>
                            <img className="w-75" src={require('../assets/contact_us_img.svg').default} alt=''/>

                        </div>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <div className="contact_white">
                            <form className="row" onSubmit={handleSubmit}>
                                <div className="col-md-12">
                                    <input type="text" className="form-control ipt_sty" placeholder="Name" name="full_name" value={formData.full_name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-12">
                                    <input type="email" className="form-control ipt_sty mt-3" placeholder="Email" name="work_email" value={formData.work_email} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-12">
                                    <input type="text" className="form-control ipt_sty mt-3" placeholder="Company (Optional)" name="company_name" value={formData.company_name} onChange={handleInputChange} />
                                </div>
                                <div className="col-md-12">
                                    <input type="text" className="form-control ipt_sty mt-3" placeholder="Phone (Optional)" name="phone_number" value={formData.phone_number} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} />
                                </div>
                                <div className="col-md-12">
                                    <textarea className="form-control ipt_sty mt-3" placeholder="Message" name="message" value={formData.message} onChange={handleInputChange}/>
                                </div>
                                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                {greenMessage && <p style={{ color: 'green' }}>{greenMessage}</p>}
                                <div className="col-md-12 mt-4">
                                    <button className="text-white Schedule_btn" type="submit">{submitloader ? <img src={require("../assets/whiteloader.gif")} alt='loader' /> : 'Get in touch'}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 contact_details mt-4">
                <div className="row py-5">
                    <div className="col-md-4 my-2">
                        <div className="d-flex align-items-center flex-wrap flex-column">
                            <img className="mb-2" src={require('../assets/phone_logo.svg').default} alt=''/>
                            <a target="_blank"  rel="noopener noreferrer" href="tel:+919025544235"><small className="text-white">+91 90255 44235</small></a>
                        </div>
                    </div>
                    <div className="col-md-4 my-2">
                        <div className="d-flex align-items-center justify-content-center flex-wrap flex-column">
                            <img className="mb-2" src={require('../assets/location_logo.svg').default} alt=''/>
                            <small className="text-white text-center">5/269, East street, Vellur post, Virudhunagar,<br/> Tamil Nadu, 626005</small>
                        </div>
                    </div>
                    <div className="col-md-4 my-2">
                        <div className="d-flex align-items-center flex-wrap flex-column">
                            <img className="mb-2" src={require('../assets/mail_logo.svg').default} alt=''/>
                            <a target="_blank"  rel="noopener noreferrer" href="mailto:support@loov.site"><small className="text-white">support@loov.site</small></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Contact
